<script>
  export default {
    /**
     *
     *
     */
    props: {
      columns: {
        default: () => [],
      },
      data: {
        default: () => [],
      },
      pages: {
        type:Object
      },
    },
    data() {
      return {
        src: require('@/assets/img/nodata.png')
      };
    },
    methods: {
      toggleRowSelection(row,selected) {
        this.$refs.table.toggleRowSelection(row,selected)
      },
      clearSelection() {
        this.$refs.table.clearSelection()
      },
      setCurrentRow(row) {
        this.$refs.table.setCurrentRow(row)
      },
      renderColumn(h, item) {
        const scopedSlots = {
          default(scope) {
            return typeof item.render === "function"
              ? item.render(h, scope)
              : scope.row[item.prop];
          },
        };

        return (
          <el-table-column show-overflow-tooltip={!item.noShowTitle}
                           {...{props: item}}
                           {...{scopedSlots}}
          ></el-table-column>
        );
      },
      renderPage() {
        if (this.pages) {
          let props = Object.assign({}, this.pages.props);
          return (
            <div class="page flex-none">
              <el-pagination
                layout="sizes, prev, pager, next, slot"
                background
                props={props}
                pageSizes={[10, 20, 50, 100]}
                on={this.pages.on}
              >
                <span class="page-info suffix">共{props.total}条</span>
              </el-pagination>
            </div>
          );
        }
      },
    },
    render(h) {
      let rowkey = this.$attrs.rowkey ? this.$attrs.rowkey : 'id';
      let firstColumn = <el-table-column type="index" align="center" label="序号" width="70" index={this.$attrs.indexMethod||(index=>index+1)}></el-table-column>;
      if (this.$attrs.firstType == 'selection') {
        firstColumn = <el-table-column type="selection" reserve-selection width="60" selectable={this.$attrs.selectable||(row=>row)}></el-table-column>
      }
      return (
        <div class="flex layout-column table">
          <el-table
              header-cell-style={{background:'#FAFAFA',color: '#333333',height: '45px',fontSize: '14px'}}
            height="100%"
            row-key={rowkey}
            ref="table"
            tooltip-effect="light"
            data={this.data}
            {...{props: this.$attrs}}
            {...{on: this.$listeners}}
          >
            {firstColumn}
            {this.columns.map((item) => this.renderColumn(h, item))}
            <template slot="empty">
              <img class="empty-image" src={ this.src }></img>
            </template>
          </el-table>
          {this.renderPage()}
        </div>
      );
    },
  };
</script>
<style scoped lang="scss">
  .flex {
    flex: 1;
  }

  .table {
    overflow: hidden;
    // min-height: 240px;

    ::v-deep .el-table {
      th.el-table__cell.is-leaf {
        border-bottom: 1px solid #E9E9E9;
      }

      .gutter {
        background: #FAFAFA;
        border-bottom: 1px solid #E9E9E9;
      }
    }

    .ell {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    /deep/ .bg {
      background: #ffffff;
    }

    .canClick {
      cursor: pointer;
      color: #108cee;
    }

    .index {
      position: relative;
      width: 30px;
      height: 30px;
      display: inline-block;
      text-align: center;
    }

  }
  .empty-image{
    width: 90px;
    padding: 10px 0 15px;
  }

  .page-info {
    opacity: 0.8;
    font-size: 13px;
    color: #838393;
    font-weight: normal;
  }
</style>
